export default __webpack_public_path__ + "static/media/(2).20b37bd1.jpg";